export enum ProfileSections {
  profile = 'profile',
  loginDetails = 'loginDetails',
  settings = 'settings',
  communications = 'communications',
  enrichedUserDetails = 'enrichedUserDetails',
  toggleTutorial = "toggleTutorial"
}
